import { Tabs as MuiTabs, styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  width: '100%',
}));

export const StickyTabs = styled(MuiTabs, {
  shouldForwardProp: (prop) => prop !== 'stickyTopHeight' && prop !== 'aboveTableChrome',
})<{ stickyTopHeight?: number; aboveTableChrome?: boolean }>(({ stickyTopHeight = 0, aboveTableChrome = false, theme }) => ({
  position: 'sticky',
  top: `${stickyTopHeight}px`,
  // Desktop table chrome sticks at 10–15. The mobile toolbar uses the fab layer, so bookmarks sit just above that.
  zIndex: aboveTableChrome ? theme.zIndex.fab + 1 : 2,
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}));

export const Content = styled('div')(() => ({
  width: '100%',
  marginTop: '10px',
}));

export const Count = styled('div')(({ theme }) => ({
  height: '18px',
  borderRadius: '4px',
  padding: '0 6px',
  fontSize: '11px !important',
  fontWeight: 700,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.error.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '8px',
}));
